import module from 'usuario/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('usuario', {
    url: '/usuario/{usuarioId}',
    template: '<usuario usuario-id="usuarioId"  data="usuario"/>',
    resolve: {
      usuario: (Usuario, $stateParams) => {
        return Usuario.get($stateParams.usuarioId)
          .then(({data}) => data)
      },
      usuarioId: ($stateParams) => $stateParams.usuarioId
    },
    controller: ($scope, usuarioId, usuario) => {
      $scope.usuarioId = usuarioId
      $scope.usuario = usuario
    },
    data: {
      title: '{{usuario.nombre}} {{usuario.apellidos}}',
    },
  })
})



// WEBPACK FOOTER //
// ./src/usuario/routes/usuario.js